import { writable } from 'svelte/store';

/**
 * Tracks the last selection for each editor to preserve it when the editor loses focus
 */
class SelectionTracker {
  constructor() {
    this.selections = new Map();
  }

  updateSelection(editorId, selection) {
    if (selection && !selection.empty) {
      this.selections.set(editorId, {
        from: selection.from,
        to: selection.to,
        text: selection.text || ''
      });
    }
  }

  getSelection(editorId) {
    return this.selections.get(editorId) || null;
  }

  clearSelection(editorId) {
    this.selections.delete(editorId);
  }
}

export const selectionTracker = new SelectionTracker();

// Store for reactive updates
export const lastSelectionsStore = writable(new Map());